<template>
  <div v-show="isResourceViewActiveLocal">

    <div class="vx-row limit-width_fixed-scalable">
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>

      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToSelectCategory">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedCategory.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <ul style="margin-top: 10px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable mb-3" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button :disabled="true"
                         size="large"
                         class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                         type="filled"
                         color="">
                Select a Resource
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>

      <li v-for="(_folder, folderIndex) in folders" :key="folderIndex" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="FolderIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                      class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                      style="border-radius:0 7px 7px 0;"
                      @click="selectFolder(_folder)">
              {{ _folder.name }}
            </vs-button>

            <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
              <div class="fab_manage-topic">
                <div class="float-btn-group">
                  <button class="btn-float btn-triger input-group_prepend-slot-bg" @click="openActions">
                    <i class="icon feather icon-more-horizontal text-white" />
                  </button>
                  <div class="btn-list">
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="deleteFolder(_folder.id)">
                      <i class="icon feather icon-trash-2 text-danger" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="editFolder(_folder)">
                      <i class="icon feather icon-edit text-white" />
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </vx-input-group>
        </vx-card>
      </li>

      <li v-for="(_resource, resourceIndex) in allResources.filter(x => !x.termId && !x.gradeId)" :key="resourceIndex + 'a'" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectResource(_resource)">
              {{ _resource.name }}
            </vs-button>

            <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
              <div class="fab_manage-topic">
                <div class="float-btn-group">
                  <button class="btn-float btn-triger input-group_prepend-slot-bg" @click="openActions">
                    <i class="icon feather icon-more-horizontal text-white" />
                  </button>
                  <div class="btn-list">
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="deleteResource(_resource.topicId)">
                      <i class="icon feather icon-trash-2 text-danger" />
                    </a>
                    <a class="btn-float dc_dark-purple description glow-effect_dark" @click="editResource(_resource)">
                      <i class="icon feather icon-edit text-white" />
                    </a>
                  </div>
                </div>
              </div>
            </span>
          </vx-input-group>
        </vx-card>
      </li>

      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <vs-collapse v-if="terms_resourceswithtermbutnograde.length > 0 || grades_resourceswithgradesandterms.length > 0 || grades_resourceswithgradebutnoterm.length > 0" id="collapse" accordion type="border" class="mb-3">
          <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down"  v-for="(_term, termIndex) in terms_resourceswithtermbutnograde" :key="termIndex + 'b'">
            <div slot="header">
              <h4><strong>{{ _term.name }}</strong></h4>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ul class="text-left q-and-a_list" style="flex-wrap: wrap;">
                  <li v-for="(_resource, termResourceIndex) in allResources.filter(x => x.termId && !x.gradeId && x.termId == _term.id)" :key="termResourceIndex + 'c'" class="mb-4">
                    <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg">
                            <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button size="large"
                                  class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                                  style="border-radius:0 7px 7px 0;"
                                  @click="selectResource(_resource)">
                          {{ _resource.name }}
                        </vs-button>

                        <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
                          <a class="inline-btn description" @click.stop.prevent="editResource(_resource)">
                            <i class="icon feather icon-edit text-white" />
                          </a>
                          <a class="inline-btn description" @click.stop.prevent="deleteResource(_resource.topicId)">
                            <i class="icon feather icon-trash-2 text-danger" />
                          </a>
                        </span>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </div>
            </div>
          </vs-collapse-item>

          <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down" v-for="(_grade, gradeIndex) in grades_resourceswithgradebutnoterm" :key="gradeIndex + 'd'">
            <div slot="header">
              <h4><strong>{{ _grade.name }}</strong></h4>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ul class="text-left q-and-a_list" style="flex-wrap: wrap;">
                  <li v-for="(_resource, gradeResourceIndex) in allResources.filter(x => !x.termId && x.gradeId)" :key="gradeResourceIndex + 'e'" class="mb-4">
                    <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg">
                            <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button size="large"
                                  class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                                  style="border-radius:0 7px 7px 0;"
                                  @click="selectResource(_resource)">
                          {{ _resource.name }}
                        </vs-button>

                        <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
                          <a class="inline-btn description" @click.stop.prevent="editResource(_resource)">
                            <i class="icon feather icon-edit text-white" />
                          </a>
                          <a class="inline-btn description" @click.stop.prevent="deleteResource(_resource.topicId)">
                            <i class="icon feather icon-trash-2 text-danger" />
                          </a>
                        </span>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </div>
            </div>

            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li v-for="(_term, termGradeIndex) in terms_resourceswithtermsandgrades" :key="termGradeIndex + 'f'" class="mb-4">
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
                  <vx-input-group>
                    <vs-button :disabled="true"
                                size="large"
                                class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                                type="filled"
                                color="">
                      {{ _term.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>

                <ul>
                  <li v-for="(_resource, termGradeResourceIndex) in allResources.filter(x => x.termId == _term.id && x.gradeId == _grade.id)" :key="termGradeResourceIndex + 'g'" class="mb-4">
                    <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg">
                            <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button size="large"
                                  class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                                  style="border-radius:0 7px 7px 0;"
                                  @click="selectResource(_resource)">
                          {{ _resource.name }}
                        </vs-button>

                        <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
                          <a class="inline-btn description" @click.stop.prevent="editResource(_resource)">
                            <i class="icon feather icon-edit text-white" />
                          </a>
                          <a class="inline-btn description" @click.stop.prevent="deleteResource(_resource.topicId)">
                            <i class="icon feather icon-trash-2 text-danger" />
                          </a>
                        </span>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </li>
            </div>
          </vs-collapse-item>

          <vs-collapse-item icon-pack="feather" icon-arrow="icon-chevron-down" v-for="(_grade, gradeIndex) in grades_resourceswithgradesandterms" :key="gradeIndex + 'd'">
            <div slot="header">
              <h4><strong>{{ _grade.name }}</strong></h4>
            </div>

            <div class="limit-width_fixed-scalable" style="text-align: left;">
              <li v-for="(_term, termGradeIndex) in terms_resourceswithtermsandgrades" :key="termGradeIndex + 'f'" class="mb-4">
                <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
                  <vx-input-group>
                    <vs-button :disabled="true"
                                size="large"
                                class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-font-color bg-color"
                                type="filled"
                                color="">
                      {{ _term.name }}
                    </vs-button>
                  </vx-input-group>
                </vx-card>

                <ul>
                  <li v-for="(_resource, termGradeResourceIndex) in allResources.filter(x => x.termId == _term.id && x.gradeId == _grade.id)" :key="termGradeResourceIndex + 'g'" class="mb-4">
                    <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text input-group_prepend-slot-bg">
                            <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button size="large"
                                  class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                                  style="border-radius:0 7px 7px 0;"
                                  @click="selectResource(_resource)">
                          {{ _resource.name }}
                        </vs-button>

                        <span id="manage-topic-fab" v-if="$acl.not.check('Student')">
                          <a class="inline-btn description" @click.stop.prevent="editResource(_resource)">
                            <i class="icon feather icon-edit text-white" />
                          </a>
                          <a class="inline-btn description" @click.stop.prevent="deleteResource(_resource.topicId)">
                            <i class="icon feather icon-trash-2 text-danger" />
                          </a>
                        </span>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </li>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
      
      <div v-if="$acl.not.check('Student')" >
        <li class="mb-4 mt-6">            
          <vx-card class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 65px;">
                  <span><feather-icon class="pt-1 ml-2" icon="PlusIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                id="add-standalone-content-btn"
                size="large"
                class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                style="border-radius:0 7px 7px 0;"
                color=""
                @click="addFolder">
                Add a Folder
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
        <li>            
          <vx-card class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 65px;">
                  <span><feather-icon class="pt-1 ml-2" icon="PlusIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                id="add-standalone-content-btn"
                size="large"
                class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                style="border-radius:0 7px 7px 0;"
                color=""
                @click="addResource">
                Add a Resource
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    isResourceViewActive: {
      required: false,
    },
    selectedCategory: {
      type: Object,
      required: true
    },
    allResources: {
      type: Array,
      required: false
    },
    folders: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      terms_resourceswithtermbutnograde: [],
      grades_resourceswithgradebutnoterm: [],
      terms_resourceswithtermsandgrades: [],
      grades_resourceswithgradesandterms: [],
      fabElement: null
    };
  },
  watch: {
    isResourceViewActive: function(val) {
      if(val){
        var self = this;
        if(self.selectedCategory.id) {

          self.terms_resourceswithtermbutnograde = [];
          self.grades_resourceswithgradebutnoterm = [];
          self.terms_resourceswithtermsandgrades = [];
          self.grades_resourceswithgradesandterms = [];

          var temp_terms_from_resources_with_only_terms = [];
          var termNoGradeResources = self.allResources.filter(x => x.termId && !x.gradeId);
          temp_terms_from_resources_with_only_terms = termNoGradeResources.map(function(item) {
            return { id: item.termId, name: item.termName };
          });
          
          temp_terms_from_resources_with_only_terms.filter(function(item) {
            return termNoGradeResources.map(function(_resource) {
              return _resource.termId; 
            }).includes(item.id);
          }).forEach(_term => {
            if (self.terms_resourceswithtermbutnograde.filter(function(item) {
              return _term.id == item.id
            }).length == 0 && _term.id != null)
              self.terms_resourceswithtermbutnograde.push(_term);
          });

          self.terms_resourceswithtermbutnograde = self.terms_resourceswithtermbutnograde.sort((a, b) => a.name > b.name ? 1 : -1); 

          var temp_grades_from_resources_with_only_grades = [];
          var gradeNoTermResources = self.allResources.filter(x => !x.termId && x.gradeId);
          temp_grades_from_resources_with_only_grades = gradeNoTermResources.map(function(item) {
            return { id: item.gradeId, name: item.gradeName };
          });
          
          temp_grades_from_resources_with_only_grades.filter(function(item) {
            return gradeNoTermResources.map(function(_resource) {
              return _resource.gradeId; 
            }).includes(item.id);
          }).forEach(_grade => {
            if (self.grades_resourceswithgradebutnoterm.filter(function(item) {
              return _grade.id == item.id
            }).length == 0 && _grade.id != null)
              self.grades_resourceswithgradebutnoterm.push(_grade);
          });

          self.grades_resourceswithgradebutnoterm= self.grades_resourceswithgradebutnoterm.sort((a, b) => a.name > b.name ? 1 : -1); 

          if (self.grades_resourceswithgradebutnoterm.length == 0) {
            var temp_resourcesWithGrades = [];
            var resourcesWithGrades = self.allResources.filter(x => x.gradeId);
            temp_resourcesWithGrades = resourcesWithGrades.map(function(item) {
              return { id: item.gradeId, name: item.gradeName };
            });

            temp_resourcesWithGrades.filter(function(item) {
              return resourcesWithGrades.map(function(_resource) {
                return _resource.gradeId; 
              }).includes(item.id);
            }).forEach(_grade => {
              if (self.grades_resourceswithgradesandterms.filter(function(item) {
                return _grade.id == item.id
              }).length == 0 && _grade.id != null)
                self.grades_resourceswithgradesandterms.push(_grade);
            });

            self.grades_resourceswithgradesandterms = self.grades_resourceswithgradesandterms.sort((a, b) => a.name > b.name ? 1 : -1); 
          }

          var temp_terms_from_resources_terms_and_grades = [];
          var termsAndGradesResources = self.allResources.filter(x => x.termId && x.gradeId);
          temp_terms_from_resources_terms_and_grades = termsAndGradesResources.map(function(item) {
            return { id: item.termId, name: item.termName };
          });
          
          temp_terms_from_resources_terms_and_grades.filter(function(item) {
            return termsAndGradesResources.map(function(_resource) {
              return _resource.termId; 
            }).includes(item.id);
          }).forEach(_term => {
            if (self.terms_resourceswithtermsandgrades.filter(function(item) {
              return _term.id == item.id
            }).length == 0 && _term.id != null)
              self.terms_resourceswithtermsandgrades.push(_term);
          });

          self.terms_resourceswithtermsandgrades = self.terms_resourceswithtermsandgrades.sort((a, b) => a.name > b.name ? 1 : -1); 
          
        }
      }
    },
  },
  computed: {
    isResourceViewActiveLocal: {
      get() {
        return this.isResourceViewActive;
      }
    }
  },
  methods: {
    selectResource(resource) {
      var self = this;
      self.$emit("resourceSelected", resource);
    },
    backToSelectCategory() {
      this.$emit("backToSelectCategory");
    },
    selectFolder(folder) {
      this.$emit("folderSelected", folder);
    },
    addFolder() {
      this.$emit("addFolder");
    },
    addResource() {
      this.$emit("addResource");
    },
    editFolder(folder) {
      var self = this;
      self.closeActions();
      self.$emit("editFolder", folder);
    },
    deleteFolder(folderId) {
      var self = this;
      self.closeActions();
      self.$emit("deleteFolder", folderId)  
    },
    editResource(resource) {
      var self = this;
      self.closeActions();
      self.$emit("editResource", resource);
    },
    deleteResource(resourceId) {
      var self = this;
      self.closeActions();
      self.$emit("deleteResource", resourceId)  
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    }
  }
};
</script>
<style lang="scss">
  .vs-collapse {
    h4 {
      margin-bottom: 0 !important;
    }
  }

  .inline-btn {
    padding-top: 0.6rem !important;
    padding-right: 1.5rem !important;
    font-size: 1.4rem !important;
  }
</style>
